import { Box, Typography } from "@mui/joy";

interface LoadingCandidatesProps {
  message?: string;
}

const LoadingCandidates: React.FC<LoadingCandidatesProps> = ({ 
  message = "Loading people..." 
}) => {
  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              border: '3px solid #e0e0e0',
              borderTop: '3px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}
          />
          <Typography level="body-sm" sx={{ color: '#666' }}>
            {message}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default LoadingCandidates; 